export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    fontSize: 13,
    color: "#060F1A",
    borderColor: state.isFocused ? "#4698CB" : "#e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(70,152,203,0.15)" : "none",
    borderRadius: 7,
    "&:hover": { borderColor: "#4698CB" },
    cursor: "pointer",
    transition: "border-color 0.15s, box-shadow 0.15s",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    padding: "8px 12px",
    borderRadius: 8,
    backgroundColor: state.isSelected
      ? "#154068"
      : state.isFocused
      ? "#eef4fb"
      : "transparent",
    color: state.isSelected ? "#fff" : "#0f1b2a",
    cursor: "pointer",
    "&:active": { backgroundColor: "#e2edf7" },
  }),
  placeholder: (base) => ({ ...base, fontSize: 13, color: "#94a3b8" }),
  singleValue: (base) => ({ ...base, fontSize: 13, color: "#060F1A" }),
  multiValue: (base) => ({ ...base, background: "#e8f0fb", borderRadius: 4 }),
  multiValueLabel: (base) => ({ ...base, color: "#154068", fontSize: 12 }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#4698CB",
    "&:hover": { background: "#c5d9ef", color: "#154068" },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: 10,
    fontSize: 13,
    overflow: "hidden",
    boxShadow: "0 8px 28px rgba(15,27,42,0.14)",
    border: "1px solid #eef1f5",
  }),
  menuList: (base) => ({ ...base, padding: 5 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "#94a3b8", padding: "0 8px" }),
  clearIndicator: (base) => ({ ...base, color: "#94a3b8", padding: "0 6px" }),
  input: (base) => ({ ...base, outline: "none", boxShadow: "none" }),
};
